export default {
  form: {
    header: {
      label: 'Encabezado',
      placeholder: 'Encabezado',
    },
    sub_header: {
      label: 'Subencabezado',
      placeholder: 'Subencabezado',
    },
    qr_code_header: {
      label: 'Título del cuadro',
      placeholder: 'Título del cuadro',
    },
    qr_code_description: {
      label: 'Descripción del cuadro',
      placeholder: 'Descripción del cuadro',
    },
    footer: {
      label: 'Texto del pie',
      placeholder: 'Ingrese texto del pie',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleccionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Color primario',
    },
    background_color: {
      label: 'Color de fondo',
    },
    cover_image: {
      label: 'Imagen de portada',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el folleto',
  },
};
